import React from 'react';
import SkillBlock from '../../components/SkillBlock';
import skills from '../../consts/skills';

const Skills = ({ t, skillsData }) => {
  return (
    <section className="skills">
      <h2 className="h2">{t.title}</h2>
      <div className="skills__content">
        {Object.keys(skills).map(id => (
          <SkillBlock 
            key={id} 
            title={skillsData[id]} 
            category={id}
          />
        ))}
      </div>
    </section>
  );
};

export default Skills;
